import {actionTypeGenerator, stateGenerator} from "../utils";
import {ORGANIZATION_DEMAND} from "./organization";

export const ORGANIZATION_MEMBERSHIP_ADMIN = actionTypeGenerator('organizationMembershipAdmin');
export const ORGANIZATION_MEMBERSHIP_COURSE_CREATOR = actionTypeGenerator('organizationMembershipCourseCreator');


let initialState = {
  admin: stateGenerator(true),
  courseCreator: stateGenerator(true),
};

export function organizationMembership(state = initialState, action) {
  switch (action.type) {
    /** Admin resource  */
    case ORGANIZATION_MEMBERSHIP_ADMIN.list.loading:
      return {
        ...state,
        admin: {
          ...state.admin, data: null,
          list: {...state.admin.list, isLoading: true}
        }
      };

    case ORGANIZATION_MEMBERSHIP_ADMIN.loading:
      return {
        ...state,
        admin: {
          ...state.admin,
          isLoading: true
        }
      };

    case ORGANIZATION_MEMBERSHIP_ADMIN.delete:
      return {
        ...state,
        admin: {
          ...state.admin,
          data: action.payload, isLoading: false,
          list: {
            data: state.admin.list.data.filter(item => item.id !== action.payload)
          }
        }
      };

    case ORGANIZATION_MEMBERSHIP_ADMIN.create:
      return {
        ...state,
        admin: {
          ...state.admin,
          data: action.payload, isLoading: false,
        }
      };

    case ORGANIZATION_MEMBERSHIP_ADMIN.list.get:
      return {
        ...state,
        admin: {
          ...state.admin,
          list: {
            ...state.admin.list,
            data: action.payload.results,
            count: action.payload.count,
            isLoading: false
          }
        }
      };

    case ORGANIZATION_MEMBERSHIP_ADMIN.error:
      return {
        ...state,
        admin: {
          ...state.admin,
          error: action.payload, isLoading: false
        }
      };

    case ORGANIZATION_MEMBERSHIP_ADMIN.list.error:
      return {
        ...state,
        admin: {
          ...state.admin,
          list: {...state.admin.list, error: action.payload, isLoading: false}
        }
      };

    /** Course creator resource  */
    case ORGANIZATION_MEMBERSHIP_COURSE_CREATOR.list.loading:
      return {
        ...state,
        courseCreator: {
          ...state.courseCreator, data: null,
          list: {...state.courseCreator.list, isLoading: true}
        }
      };

    case ORGANIZATION_MEMBERSHIP_COURSE_CREATOR.loading:
      return {
        ...state,
        courseCreator: {
          ...state.courseCreator,
          isLoading: true
        }
      };

    case ORGANIZATION_MEMBERSHIP_COURSE_CREATOR.delete:
      return {
        ...state,
        courseCreator: {
          ...state.courseCreator,
          data: action.payload, isLoading: false,
          list: {
            data: state.courseCreator.list.data.filter(item => item.id !== action.payload)
          }
        }
      };

    case ORGANIZATION_MEMBERSHIP_COURSE_CREATOR.create:
      return {
        ...state,
        courseCreator: {
          ...state.courseCreator,
          data: action.payload, isLoading: false,
        }
      };

    case ORGANIZATION_MEMBERSHIP_COURSE_CREATOR.list.get:
      return {
        ...state,
        courseCreator: {
          ...state.courseCreator,
          list: {
            ...state.courseCreator.list,
            data: action.payload.results,
            count: action.payload.count,
            isLoading: false
          }
        }
      };

    case ORGANIZATION_MEMBERSHIP_COURSE_CREATOR.list.error:
      return {
        ...state,
        courseCreator: {
          ...state.courseCreator,
          list: {...state.courseCreator.list, error: action.payload, isLoading: false}
        }
      };

    case ORGANIZATION_MEMBERSHIP_COURSE_CREATOR.error:
      return {
        ...state,
        courseCreator: {
          ...state.courseCreator,
          error: action.payload, isLoading: false
        }
      };

    default:
      return state;

  }
}